// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Gt-z","giftOrPromoSelector":"Ht-z","disabled":"It-z","subTitle":"Jt-z","selectShipAddressMessage":"Kt-z","changePayment":"Lt-z"};